window.onload = async () => {
  const cookie_return_url = getCookie("return_to");
  const checkout_url = getCheckoutUrl('checkout_url');
  let return_to = "https://honda-fun-shop.com/account"
  if(cookie_return_url != null && cookie_return_url != undefined && cookie_return_url != "" && checkout_url != undefined && checkout_url != null && checkout_url != ""){
    return_to = cookie_return_url;
  }
  return_to = btoa(return_to);
  return_to = return_to.replace(/\+/g, '-').replace(/\//g, '_');
  // 遷移元URL
  let transitionSourceUrl =
    "https://honda-fun-shop.com/pages/login-callback".concat(
      "?href=",
      return_to
    );

  const CIAM_AUTH_ENDPOINT = `${theme.api.ciam_domain}${theme.routes.ciam_auth}`
    .concat("?scope=", "openid profile email offline_access")
    .concat("&response_type=", "code")
    .concat("&client_id=", theme.api.ciam_client_id)
    .concat("&redirect_uri=", transitionSourceUrl)
    .concat("&audience=", theme.api.ciam_audience);

  const anchor = document.createElement("a");
  anchor.href = CIAM_AUTH_ENDPOINT;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname,value) {
    document.cookie = cname + "=" + escape (value) + "; path=/";
}
function getCheckoutUrl(key) {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}